import {
  LuBookOpen, LuChartColumn, LuCirclePlus, LuClock, LuFileText, LuFolder, LuLayoutGrid,
  LuList, LuSearch, LuSlidersHorizontal, LuTag, LuWandSparkles,
} from 'react-icons/lu';
import { moduleTour as tour, OPTIONAL as opt } from '../defineTour';

// Landing-tab tour first; one tour per further tab below it.
const tours = [
  // exact: article, category and create pages live under this path.
  tour('knowledge', '/knowledge-system', 'knowledge_system', [
    ['tabs', 'knowledge.tabs', LuBookOpen],
    ['search', 'knowledge.search', LuSearch, opt],
    ['mode', 'knowledge.mode', LuWandSparkles, opt],
    ['categories', 'knowledge.categories', LuLayoutGrid, { placement: 'top', ...opt }],
  ], { exact: true }),

  tour('knowledge_dashboard', '/knowledge-system/dashboard', 'knowledge_system', [
    ['new', 'knowledge_dashboard.new', LuCirclePlus, { placement: 'left' }],
    ['search', 'knowledge_dashboard.search', LuSearch],
    ['stats', 'knowledge_dashboard.stats', LuChartColumn, opt],
    ['recent', 'knowledge_dashboard.recent', LuClock, { placement: 'top', ...opt }],
  ], { exact: true }),

  tour('knowledge_articles', '/knowledge-system/list', 'knowledge_system', [
    ['header', 'knowledge_articles.header', LuFileText],
    ['create', 'knowledge_articles.create', LuCirclePlus, { placement: 'left', ...opt }],
    ['filters', 'knowledge_articles.filters', LuSlidersHorizontal, opt],
    ['list', 'knowledge_articles.list', LuList, { placement: 'top', ...opt }],
  ], { exact: true }),

  tour('knowledge_categories', '/knowledge-system/categories', 'knowledge_system', [
    ['new', 'knowledge_categories.new', LuFolder, { placement: 'left' }],
    ['search', 'knowledge_categories.search', LuSearch, opt],
    ['list', 'knowledge_categories.list', LuList, { placement: 'top', ...opt }],
  ], { exact: true }),

  tour('knowledge_tags', '/knowledge-system/tags', 'knowledge_system', [
    ['new', 'knowledge_tags.new', LuTag, { placement: 'left' }],
    ['search', 'knowledge_tags.search', LuSearch, opt],
    ['list', 'knowledge_tags.list', LuList, { placement: 'top', ...opt }],
  ], { exact: true }),
];

export default tours;
